import React, { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faXmark } from "@fortawesome/free-solid-svg-icons";
import MemberCard from "./memberCard";
import { findBelt } from "./cardsData";

// Gallery-style viewer: the chosen card is enlarged in the centre with the page dimmed
// behind it. Click the card to flip it and see the QR code. Esc closes, arrows browse.
const CardLightbox = ({ belts, index, user, onClose, onChange }) => {
  const [flipped, setFlipped] = useState(false);
  const belt = belts[index];
  const many = belts.length > 1;

  const go = useCallback(
    (step) => onChange((index + step + belts.length) % belts.length),
    [index, belts.length, onChange]
  );

  useEffect(() => setFlipped(false), [index]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      else if (many && e.key === "ArrowLeft") go(-1);
      else if (many && e.key === "ArrowRight") go(1);
      else if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        setFlipped((f) => !f);
      }
    };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [go, many, onClose]);

  return createPortal(
    <div className="lightbox" role="dialog" aria-modal="true" onClick={onClose}>
      <button type="button" className="lightbox-close" onClick={onClose} aria-label="Փակել">
        <FontAwesomeIcon icon={faXmark} />
      </button>
      {many && (
        <button
          type="button"
          className="lightbox-arrow prev"
          onClick={(e) => {
            e.stopPropagation();
            go(-1);
          }}
          aria-label="Նախորդը"
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
      )}
      <div className="lightbox-stage" onClick={(e) => e.stopPropagation()}>
        <MemberCard belt={belt} user={user} flipped={flipped} onClick={() => setFlipped((f) => !f)} />
        <p className="lightbox-caption">
          {findBelt(belt)?.label} · Սեղմեք քարտի վրա՝ շրջելու համար
        </p>
      </div>
      {many && (
        <button
          type="button"
          className="lightbox-arrow next"
          onClick={(e) => {
            e.stopPropagation();
            go(1);
          }}
          aria-label="Հաջորդը"
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      )}
    </div>,
    document.body
  );
};

export default CardLightbox;
